module.exports = __webpack_public_path__ + "img/0004.afcabb7f.jpg";